import { Link } from 'gatsby';
import React from 'react';
import links from '../../data/links.json';
import products from '../../data/products.json';
import SocialIcons from './Social';

const Footer = () => (
  <div className="bg-gray-50">
    <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:py-16 lg:px-8">
      <div className="xl:grid xl:grid-cols-2 xl:gap-8">
        <div className="grid grid-cols-2 gap-8 xl:col-span-2">
          <div className="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h4 className="text-sm font-semibold leading-5 tracking-wider text-gray-400 uppercase">
                Products
              </h4>
              <ul className="mt-4 text-sm">
                <li>
                  <Link
                    to={products.GA01.link}
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Mail Merge for Gmail
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to={products.GA16.link}
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Document Studio
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to={products.GA11.link}
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Email Spreadsheet Dashboards
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to={products.GA08.link}
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Form Notifications
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to="/#products"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Google Workspace Add-ons
                  </Link>
                </li>
              </ul>
            </div>
            <div className="mt-12 md:mt-0">
              <h4 className="text-sm font-semibold leading-5 tracking-wider text-gray-400 uppercase">
                Help Center
              </h4>
              <ul className="mt-4 text-sm">
                <li>
                  <Link
                    to="/support"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Contact Customer Support
                  </Link>
                </li>
                <li className="mt-4">
                  <a
                    href="https://digitalinspiration.com/docs/mail-merge"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Mail Merge for Gmail Guides
                  </a>
                </li>
                <li className="mt-4">
                  <a
                    href="https://digitalinspiration.com/docs/form-notifications"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Google Form Notification Guides
                  </a>
                </li>
                <li className="mt-4">
                  <a
                    href="https://digitalinspiration.com/docs/document-studio/google-sheets"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Google Sheets Automation
                  </a>
                </li>
                <li className="mt-4">
                  <a
                    href="https://digitalinspiration.com/docs/document-studio/google-forms"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Google Forms Automation
                  </a>
                </li>
                <li className="mt-4">
                  <a
                    href="https://digitalinspiration.com/docs/email-google-sheets"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Schedule and Email Google Sheets
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h4 className="text-sm font-semibold leading-5 tracking-wider text-gray-400 uppercase">
                Company
              </h4>
              <ul className="mt-4 text-sm">
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={links.DEVELOPER}
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Google Developer Expert
                  </a>
                </li>
                <li className="mt-4">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={links.BLOG}
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Technology Blog
                  </a>
                </li>
                <li className="mt-4">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.labnol.org/topic/google-apps-script"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Made with Google Apps Script
                  </a>
                </li>
                <li className="mt-4">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://github.com/labnol"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Open Source Work
                  </a>
                </li>
                <li className="mt-4">
                  <a
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    href="https://docs.google.com/forms/d/e/1FAIpQLScm-Sta5r85AwxgOBOc4CRRS7j4s2bYpnNIfbm6v49nk8GomA/viewform"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Report a security vulnerability
                  </a>
                </li>
                <li className="mt-4">
                  <Link
                    to="/changelog"
                    className="text-gray-500 hover:text-gray-900"
                    title="Changelog and Release Notes"
                  >
                    Changelog and Release Notes
                  </Link>
                </li>
              </ul>
            </div>
            <div className="mt-12 md:mt-0">
              <h4 className="text-sm font-semibold leading-5 tracking-wider text-gray-400 uppercase">
                Legal
              </h4>
              <ul className="mt-4 text-sm">
                <li>
                  <Link
                    to="/gdpr"
                    className="text-gray-500 hover:text-gray-900"
                    title="GDPR"
                  >
                    GDPR Compliance
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to="/eula"
                    className="text-gray-500 hover:text-gray-900"
                    title="End User License Agreement"
                  >
                    EULA
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    title="View our privacy policy"
                    to="/privacy"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to="/privacy#terms"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to="/google"
                    className="text-gray-500 hover:text-gray-900"
                    title="Compliance and adherence to the Google API Services User Data Policy"
                  >
                    Limited Use Disclosure
                  </Link>
                </li>
                <li className="mt-4">
                  <Link
                    to="/accessibility"
                    className="text-gray-500 hover:text-gray-900"
                    title="Our Accessibility Commitment"
                  >
                    Web Accessibility
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="pt-8 mt-8 border-t border-gray-200 md:flex md:items-center md:justify-between">
        <SocialIcons />
        <p className="mt-8 text-base leading-6 text-gray-400 md:mt-0 md:order-1">
          &copy; 2004 &mdash; 2025 Digital Inspiration&reg;. All rights
          reserved.
        </p>
      </div>
    </div>
  </div>
);

export default Footer;
